export { onRenderClient }

import { hydrateRoot } from 'react-dom/client'
import React from 'react'
import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'

async function onRenderClient(pageContext) {
    const { Page, data = {} } = pageContext
    const { city, cityName, cityNameNom, courts, points, lat, lng } = data

    // Use the same cache key as the server so Emotion reuses injected SSR styles
    const emotionCache = createCache({ key: 'css' })

    hydrateRoot(
        document.getElementById('root'),
        React.createElement(
            CacheProvider,
            { value: emotionCache },
            React.createElement(Page, { city, cityName, cityNameNom, courts, points, lat, lng })
        )
    )
}
